import { Button } from '@/components/ui/button.tsx'
import { type ChangeEvent, useRef } from 'react'

interface FileUploadButtonProps {
  onUpload: (files: File[]) => Promise<void>
}

export const FileUploadButton = ({ onUpload }: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || [])
    await onUpload(files)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <Button type="button" variant="ghost" size="icon" onClick={handleButtonClick} aria-label="Upload files">
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        onChange={handleFileChange}
        multiple={true}
        aria-label="File input"
      />
      <img src="/images/upload-icon.svg" alt="upload" />
    </Button>
  )
}
